import { Text } from 'react-native'
import styled from 'styled-components/native'
import { Block, BlockPropsByType, BlockType } from '../../../doclets/types'
import { builderColors } from './builderColors'

// Shared by the block settings panel and each block type's own settings

export interface BlockSettingsProps<T extends BlockType = BlockType> {
  block: Block<T>
  onChange: (props: BlockPropsByType[T]) => void
}

export const SettingLabel = styled(Text)`
  font-size: 13px;
  font-weight: 700;
  color: ${builderColors.text};
  margin-bottom: 4px;
`

export const HelpText = styled(Text)`
  font-size: 11px;
  line-height: 15px;
  color: ${builderColors.mutedText};
`
